import { InjectionToken } from '@angular/core';

import { TutorialDialogContext } from './tutorial-dialog.types';

export type TutorialDialogContentTranslation = Record<
  TutorialDialogContext,
  { [key: string]: { title: string; description: string } }
>;

export interface TutorialDialogModuleTranslations {
  dialogBody: {
    learnMore: string;
    skip: string;
    continue: string;
    finish: string;
    startTour: string;
  };
  tutorials: { [key: string]: any };
}

export const TutorialTranslations = new InjectionToken<TutorialDialogModuleTranslations>(
  'TutorialModuleTranslations',
);
